// useDebouncedValue.js
// Drop-in helper to stop high-frequency state changes (search inputs, qty fields)
// from cascading into heavy re-renders. Returns a value that only updates after
// `delay`ms of stability — typing stays snappy because filtering / sorting waits.
//
// Usage:
//   const [searchText, setSearchText] = useState("");
//   const debouncedSearch = useDebouncedValue(searchText, 200);
//   // ...feed debouncedSearch into useMemo dependencies, not searchText
//
import { useEffect, useState } from "react";

export function useDebouncedValue(value, delay = 200) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}

export default useDebouncedValue;
